import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import './DashboardAccessModal.css';

const DashboardAccessModal = ({ show, onHide }) => {
    return (
        <Modal show={show} onHide={onHide} centered className="dashboard-access-modal">
            <Modal.Header closeButton className="border-0 pb-0">
                <Modal.Title className="w-100 text-center">
                    <div className="modal-icon mb-3">🔐</div>
                    <h4 className="mb-0">Access Restricted</h4>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="text-center px-4 pb-4">
                <p className="text-muted mb-4" style={{ fontSize: '1.1rem', lineHeight: '1.6' }}>
                    Access restricted to subscribers. Please upgrade your plan to view this content.
                </p>
                <div className="d-flex justify-content-center gap-3">
                    <Button variant="outline-secondary" onClick={onHide}>
                        Close
                    </Button>
                    {/* <Button variant="primary" onClick={onHide}>
                        Upgrade Plan
                    </Button> */}
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default DashboardAccessModal; 